// extracted by mini-css-extract-plugin
export default {"loaderContainer":"CFREoa8AE4N18o5ilojI","titleContainer":"W1pRX6MyvPto5ASwvth6"};